"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSubmission = createSubmission;
exports.updateSubmission = updateSubmission;

var _immutable = require("immutable");

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _SubmissionRecord = _interopRequireDefault(require("playbooks-modal/records/SubmissionRecord"));

var baseUrl = 'playbooks/v1/submissions';

function createSubmission(_ref) {
  var playbookId = _ref.playbookId,
      source = _ref.source,
      sourceId = _ref.sourceId,
      playbookSubmissionAnswers = _ref.playbookSubmissionAnswers;
  return _apiClient.default.post(baseUrl + "/wrap", {
    data: {
      playbookSubmission: {
        playbookId: playbookId,
        objectType: source,
        objectId: sourceId
      },
      playbookSubmissionAnswers: playbookSubmissionAnswers
    }
  }).then(_immutable.fromJS).then(function (playbookSubmission) {
    return playbookSubmission.get('playbookSubmissionAnswers').reduce(function (submissionMap, submissionAnswer) {
      var submission = new _SubmissionRecord.default(submissionAnswer);
      return submissionMap.set(submission.questionId, submission);
    }, (0, _immutable.Map)());
  });
}

function updateSubmission(_ref2) {
  var playbookSubmissionId = _ref2.playbookSubmissionId,
      playbookSubmissionAnswers = _ref2.playbookSubmissionAnswers;
  return _apiClient.default.put(baseUrl + "/wrap", {
    data: {
      playbookSubmissionId: playbookSubmissionId,
      playbookSubmissionAnswers: playbookSubmissionAnswers
    }
  }).then(_immutable.fromJS).then(function (playbookSubmission) {
    return playbookSubmission.get('playbookSubmissionAnswers').reduce(function (submissionMap, submissionAnswer) {
      var submission = new _SubmissionRecord.default(submissionAnswer);
      return submissionMap.set(submission.questionId, submission);
    }, (0, _immutable.Map)());
  });
}